import React from 'react';
import { Form } from 'semantic-ui-react';
import "./index.scss"

function LabeledInput({
    label,
    prefix,
    value,
    onChange,
    type = "text",
    required = false,
    inputProps = {},
    error,
    disabled,
    isBorder
}) {

    const handleChange = (e) => {
        let newValue = e.target.value;

        if (type === "number") {
            const { min, max } = inputProps;

            if (newValue !== "") {
                const numericValue = Number(newValue);

                if (min !== undefined && numericValue < Number(min)) {
                    return;
                }

                if (max !== undefined && numericValue > Number(max)) {
                    return;
                }
            }
        }

        onChange?.(newValue);
    };

    return (
        <Form.Field required={required} disabled={disabled}>
            {label && <label>{label}</label>}

            <Form.Input labelPosition="left" disabled={disabled} error={error}>
                <div
                    className={`ui basic label LabeledInput ${isBorder ? "LabeledInput--border" : ""}`}
                >
                    {prefix}
                </div>

                <input
                    type={type}
                    value={value}
                    onChange={handleChange}
                    {...inputProps}
                    
                />
            </Form.Input>
        </Form.Field>
    );
}

export default LabeledInput;